// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"f3a73b9e","566":"242121dc","956":"9cbcc5f6"}[chunkId] + ".chunk.js";
};